// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eoPxr":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
/*
 * Lightweight deferred loader for Google Analytics .
 * Loads only after page is idle AND (optionally) user consent is granted.
 */ (function() {
    // Pulled from config.js
    // (dynamic import avoided to keep simple synchronous execution)
    var PROD_HOST, PROD_UA, DEV_UA;
    try {
        // Attempt ES module named exports if bundler transforms
        var cfg = require("4650ddbe8dcfc348"); // eslint-disable-line global-require
        PROD_HOST = cfg.ANALYTICS_PROD_HOST;
        PROD_UA = cfg.ANALYTICS_PROD_UA;
        DEV_UA = cfg.ANALYTICS_DEV_UA;
    } catch (e) {
        // Fallback hardcoded (shouldn't normally happen)
        PROD_HOST = 'next-gen.tria.connectria.com';
        PROD_UA = 'UA-154477883-1';
        DEV_UA = 'UA-154477883-2';
    }
    function loadScript(src) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_async = _ref.async, async = _ref_async === void 0 ? true : _ref_async, _ref_defer = _ref.defer, defer = _ref_defer === void 0 ? true : _ref_defer, id = _ref.id, attrs = _ref.attrs;
        if (id && document.getElementById(id)) return;
        var s = document.createElement('script');
        s.src = src;
        if (id) s.id = id;
        if (async) s.async = true;
        if (defer) s.defer = true;
        if (attrs) Object.entries(attrs).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), k = _param[0], v = _param[1];
            return s.setAttribute(k, v);
        });
        document.head.appendChild(s);
        return s;
    }
    function loadGA() {
        if (window.gtag) return; // already loaded
        var ua = window.location.host.indexOf(PROD_HOST) > -1 ? PROD_UA : DEV_UA;
        loadScript("https://www.googletagmanager.com/gtag/js?id=".concat(ua), {
            async: true,
            defer: true,
            id: 'gtag-lib'
        });
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        } // eslint-disable-line
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', ua, {
            anonymize_ip: true
        });
    }
    function init() {
        loadGA();
    }
    function schedule() {
        if ('requestIdleCallback' in window) requestIdleCallback(init, {
            timeout: 4000
        });
        else window.addEventListener('load', function() {
            return setTimeout(init, 1500);
        });
    }
    schedule();
})();

},{"@swc/helpers/_/_sliced_to_array":"byksX","4650ddbe8dcfc348":"kQzX9"}]},["eoPxr"], "eoPxr", "parcelRequire94c2")

//# sourceMappingURL=index.1a64c0e1.js.map
